var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_734",
    "data-name": "Group 734",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.583,
    height: 82.865,
    viewBox: "0 0 89.583 82.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(6.306 5.763)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 38.487,
    cy: 35.334,
    rx: 38.487,
    ry: 35.334,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "0.249 7.976"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(11.562 32.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M95.169,127.432a1.781,1.781,0,0,1-1.78,1.78H30.49a1.781,1.781,0,0,1-1.78-1.78V82.24a1.781,1.781,0,0,1,1.78-1.78h62.9a1.781,1.781,0,0,1,1.78,1.78Z",
    transform: "translate(-28.71 -80.46)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 63.471,
    height: 42.131,
    transform: "translate(1.494 2.819)",
    fill: "#e8e5ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M108.545,196.207a.442.442,0,0,1-.443.443H97.873a.442.442,0,0,1-.443-.443h0a.445.445,0,0,1,.443-.447H108.1a.445.445,0,0,1,.443.447Z",
    transform: "translate(-69.756 -149.328)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M109.582,83.649a.418.418,0,0,1-.419.419h-5.984a.418.418,0,0,1-.419-.419h0a.418.418,0,0,1,.419-.419h5.984a.416.416,0,0,1,.419.419Z",
    transform: "translate(-72.939 -82.114)",
    fill: "#f3a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(1.494 2.819)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M110.072,87.46h-7.7L57.16,129.591h8.521Z",
    transform: "translate(-47.197 -87.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M84.414,87.46H73.935S32.46,124.694,32.42,124.694v4.9h5.992Z",
    transform: "translate(-32.42 -87.46)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(8.441 8.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M38.534,29.547a8.787,8.787,0,1,1-8.787-8.787A8.788,8.788,0,0,1,38.534,29.547Z",
    transform: "translate(-20.96 -20.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(2.505 2.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(0 1.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 1.486,
    height: 9.472,
    transform: "translate(9.987)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 1.486,
    height: 5.541,
    transform: "translate(2.497 3.93)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 1.486,
    height: 8.191,
    transform: "translate(7.49 1.281)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 1.486,
    height: 7.023,
    transform: "translate(4.994 2.448)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 1.486,
    height: 4.482,
    transform: "translate(0 4.99)",
    fill: "#9c2eff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(0.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(0 0.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M27.576,33.48a.2.2,0,0,1-.173-.1.2.2,0,0,1,.077-.27l8.92-4.921a.2.2,0,0,1,.27.077.2.2,0,0,1-.077.27l-8.924,4.925A.187.187,0,0,1,27.576,33.48Z",
    transform: "translate(-27.378 -28.16)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M47.983,29.238l.612-1.595-1.7-.173Z",
    transform: "translate(-39.038 -27.47)",
    fill: "#2d4199"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(0 30.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M17.9,84.542A8.952,8.952,0,1,1,8.952,75.59,8.951,8.951,0,0,1,17.9,84.542Z",
    transform: "translate(0 -75.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(2.626 3.399)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 1.273,
    height: 3.632,
    transform: "translate(2.308 7.474)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 1.945,
    height: 1.152,
    transform: "translate(1.969 6.681)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M32.59,89.73v4.45a2.226,2.226,0,0,0,0-4.45Z",
    transform: "translate(-22.091 -87.435)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M8.135,91.14v3.334a1.668,1.668,0,0,1,0-3.334Z",
    transform: "translate(-6.52 -88.277)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M22.062,85.18c-3.753,1.7-5.7,1.591-5.7,1.591v4.853a11.2,11.2,0,0,1,5.7,1.623Z",
    transform: "translate(-12.397 -84.717)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 3.411,
    height: 4.998,
    transform: "translate(0.983 2.001)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 1.587,
    height: 8.735,
    transform: "translate(9.355)",
    fill: "#f3a51c"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(71.678 31.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M195.894,88.042a8.952,8.952,0,1,1-8.952-8.952A8.951,8.951,0,0,1,195.894,88.042Z",
    transform: "translate(-177.99 -79.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(3.326 3.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M194.054,92.96c0,.117-4.164-3.789-4.164-3.789a5.613,5.613,0,0,1,4.164-1.84Z",
    transform: "translate(-188.424 -87.33)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M205.85,92.96h-5.63V87.33A5.628,5.628,0,0,1,205.85,92.96Z",
    transform: "translate(-194.594 -87.33)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M186.25,101.33h5.63v5.63A5.635,5.635,0,0,1,186.25,101.33Z",
    transform: "translate(-186.25 -95.692)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M191.88,95.689h-5.63a5.621,5.621,0,0,1,1.466-3.789Z",
    transform: "translate(-186.25 -90.06)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(5.63 5.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M200.23,101.326c0-.117,4.164,3.789,4.164,3.789a5.613,5.613,0,0,1-4.164,1.84Z",
    transform: "translate(-200.23 -101.324)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M200.23,101.33h5.63a5.621,5.621,0,0,1-1.466,3.789Z",
    transform: "translate(-200.23 -101.327)",
    fill: "#140578"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(33.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M102.736,9.8a9.8,9.8,0,1,1-9.8-9.8A9.8,9.8,0,0,1,102.736,9.8Z",
    transform: "translate(-83.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M104.417,13.213H102.19l1.526-1.623-2.573-2.416-1.269,1.349V8.67H96.343V10.9L94.72,9.371,92.3,11.944l1.349,1.269H91.8v3.532h2.227L92.5,18.367l2.573,2.416,1.269-1.349v1.852h3.532V19.06l1.623,1.526,2.416-2.573-1.349-1.269h1.852Zm-6.306,4.3a2.541,2.541,0,1,1,2.541-2.541A2.541,2.541,0,0,1,98.11,17.517Z",
    transform: "translate(-88.313 -5.179)",
    fill: "#140578"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(61.578 8.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M170.488,29.547A8.789,8.789,0,1,1,161.7,20.76,8.788,8.788,0,0,1,170.488,29.547Z",
    transform: "translate(-152.91 -20.76)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(1.961 2.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(1.047 1.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M168.317,40.34l-7.937-5.094,7.937-5.066.487.761-6.753,4.309,6.753,4.333Z",
    transform: "translate(-160.38 -30.18)",
    fill: "#140578"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M175.85,27.783A1.953,1.953,0,1,0,177.8,25.83,1.952,1.952,0,0,0,175.85,27.783Z",
    transform: "translate(-168.573 -25.83)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M157.78,38.963a2.283,2.283,0,1,0,2.283-2.283A2.284,2.284,0,0,0,157.78,38.963Z",
    transform: "translate(-157.78 -32.311)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 1.953,
    cy: 1.953,
    rx: 1.953,
    ry: 1.953,
    transform: "translate(7.277 9.58)",
    fill: "#f3a51c"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(20.164 45.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(29.068 0.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M144.616,147.57a7.54,7.54,0,0,1-.286.781,8.349,8.349,0,0,1-1.8,2.658,8.491,8.491,0,0,1-2.646,1.776,8.129,8.129,0,0,1-6.363,0,8.492,8.492,0,0,1-2.646-1.776,7.328,7.328,0,0,1-.58-.648c-.636.5-1.329.918-1.961,1.426-.04.032-.081.064-.121.1a10.1,10.1,0,0,0,.789.874,10.777,10.777,0,0,0,3.459,2.271,11.073,11.073,0,0,0,11.94-2.271,10.581,10.581,0,0,0,2.328-3.431,9.411,9.411,0,0,0,.371-1.023C146.271,148.049,145.458,147.755,144.616,147.57Z",
    transform: "translate(-125.81 -134.208)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M152.958,121.015a11.233,11.233,0,0,0-2.34-3.443,10.926,10.926,0,0,0-3.459-2.328,10.838,10.838,0,0,0-8.433,0l-.056.024,1.019,2.179a10.358,10.358,0,0,1,3.25-.636,8.218,8.218,0,0,1,5.976,2.493,8.082,8.082,0,0,1,1.707,2.674,8.728,8.728,0,0,1,.6,3.238,14.154,14.154,0,0,1-.459,2.8l2.477.761a10.951,10.951,0,0,0,.572-3.556A10.086,10.086,0,0,0,152.958,121.015Z",
    transform: "translate(-132.058 -114.39)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M125.021,133.669c.664-.544,1.349-1.067,2.05-1.562a8.41,8.41,0,0,1-1.563-2.408,8.3,8.3,0,0,1-.66-3.318,8.728,8.728,0,0,1,.6-3.238,8.052,8.052,0,0,1,4.337-4.49c.077-.036.157-.064.234-.1-.342-.725-.648-1.466-.942-2.215-.052.02-.109.04-.161.064a10.971,10.971,0,0,0-3.459,2.328,11.163,11.163,0,0,0-2.34,3.443,10.283,10.283,0,0,0-.87,4.2,10.7,10.7,0,0,0,2.771,7.293Z",
    transform: "translate(-122.25 -115.555)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(16.161 0.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M92.789,151.09H90.2v6.025h11.155v-2.368H92.789Z",
    transform: "translate(-90.2 -136.343)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M92.789,128.88H90.2v9.162h2.589v-4.414h8.32V131.26h-8.32Z",
    transform: "translate(-90.2 -123.077)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M90.2,114.47v6.025h2.589v-3.657h8.566V114.47Z",
    transform: "translate(-90.2 -114.47)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M58.249,153.8s0,0-.008,0a3.529,3.529,0,0,1-1.53.33,4.282,4.282,0,0,1-1.571-.29,3.954,3.954,0,0,1-1.3-.813,3.626,3.626,0,0,1-.854-1.252,4.1,4.1,0,0,1-.3-1.583l-2.618.552a7.088,7.088,0,0,0,.717,2.316,6.444,6.444,0,0,0,1.389,1.844,6.3,6.3,0,0,0,4.309,1.651A7.046,7.046,0,0,0,59,156.12,16.169,16.169,0,0,0,58.249,153.8Z",
    transform: "translate(-50.07 -134.909)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M53.759,120.949a6.315,6.315,0,0,0,1.446,1.075q.828.453,1.707.842l1.434.6c.33.137.656.294.983.455.4-.753.866-1.47,1.269-2.223-.395-.193-.8-.379-1.232-.548l-1.486-.58a10.424,10.424,0,0,1-1.007-.455,4.62,4.62,0,0,1-.922-.62,3.387,3.387,0,0,1-.689-.826,2.064,2.064,0,0,1-.274-1.075,2.442,2.442,0,0,1,.3-1.224,3.064,3.064,0,0,1,.8-.922,3.659,3.659,0,0,1,1.116-.592,3.961,3.961,0,0,1,1.252-.205,3.627,3.627,0,0,1,1.969.5,4.289,4.289,0,0,1,1.365,1.462l2.066-1.24a5.92,5.92,0,0,0-5.344-3.141,7.181,7.181,0,0,0-2.287.37,6.376,6.376,0,0,0-1.957,1.059,5.226,5.226,0,0,0-1.365,1.679,4.887,4.887,0,0,0-.511,2.259,4.626,4.626,0,0,0,.37,1.9A4.974,4.974,0,0,0,53.759,120.949Z",
    transform: "translate(-51.456 -112.23)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M73.26,138.606a5.509,5.509,0,0,0-1.075-1.724,6.76,6.76,0,0,0-1.639-1.281,16.679,16.679,0,0,0-1.679-.822c-.415.741-.838,1.482-1.2,2.247q.562.242,1.111.532a5.873,5.873,0,0,1,1.156.8,3.452,3.452,0,0,1,.813,1.075,3.266,3.266,0,0,1,.3,1.446,4.151,4.151,0,0,1-.29,1.554,4.092,4.092,0,0,1-.8,1.281,3.916,3.916,0,0,1-1.212.882c-.056.028-.113.044-.173.068a23.326,23.326,0,0,0,.524,2.384c.173-.052.346-.113.515-.177a6.439,6.439,0,0,0,2.106-1.337,6.112,6.112,0,0,0,1.405-2.054,6.6,6.6,0,0,0,.511-2.6A6.242,6.242,0,0,0,73.26,138.606Z",
    transform: "translate(-60.582 -125.699)",
    fill: "#9c2eff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(51.599 48.522)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 1.873,
    height: 5.819,
    transform: "translate(7.643 16.422)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M145.471,129.16a8.67,8.67,0,1,1-8.67-8.67A8.671,8.671,0,0,1,145.471,129.16Z",
    transform: "translate(-128.13 -120.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M144.98,168.5v13.334a1.674,1.674,0,0,0,1.675,1.675h.238a1.674,1.674,0,0,0,1.675-1.675V168.5Z",
    transform: "translate(-138.194 -149.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M146.395,132a6.757,6.757,0,1,1-6.757-6.757A6.756,6.756,0,0,1,146.395,132Z",
    transform: "translate(-130.967 -123.327)",
    fill: "#140578"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.af550a9f8adccc088cbd3a49bef4cbf4.svg";
export { ForwardRef as ReactComponent };